import React from 'react';
import { Hero, ProblemSolution, HowItWorks, Features, UseCasesPreview, FAQ, FinalCTA, LandingHeader, LandingFooter } from '../../components/landing';
import type { FAQItem } from '../../components/landing';

const productFaqs: FAQItem[] = [
  {
    question: 'What is a dynamic QR code?',
    answer: 'A QR code whose destination you can change after it\'s printed or published, without reprinting the code itself — the physical or digital image stays the same.',
  },
  {
    question: 'Can I change where a QR code points after it\'s already printed?',
    answer: 'Yes. Update the destination in your dashboard and every future scan goes to the new URL immediately, no reprint needed.',
  },
  {
    question: 'Is there a free plan?',
    answer: 'Yes — the Free plan includes 1 QR code and 100 scans per month, no credit card required.',
  },
  {
    question: 'What analytics do I get on scans?',
    answer: 'Scan counts over time plus breakdowns by location, device, and time — visible per QR code in your dashboard.',
  },
  {
    question: 'Can I route the same QR code differently by location, device, or time?',
    answer: 'Yes — routing rules let one QR code send people to different destinations based on where, when, or what they\'re scanning from.',
  },
  {
    question: 'Can I cancel anytime?',
    answer: 'Yes, you can cancel your subscription at any time with no cancellation fees.',
  },
];

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white scroll-smooth snap-y snap-mandatory overflow-y-auto h-screen">
      <LandingHeader />
      <div className="snap-start">
        <Hero />
      </div>
      <div className="snap-start">
        <ProblemSolution />
      </div>
      <div className="snap-start">
        <Features />
      </div>
      <div className="snap-start">
        <UseCasesPreview />
      </div>
      <div className="snap-start">
        <HowItWorks />
      </div>
      <div className="snap-start">
        <FAQ faqs={productFaqs} />
      </div>
      <div className="snap-start">
        <FinalCTA />
      </div>
      <div className="snap-start">
        <LandingFooter />
      </div>
    </div>
  );
}
